import { render, staticRenderFns } from "./advancedApprovalDataActions.vue?vue&type=template&id=510bfde4&scoped=true"
import script from "./advancedApprovalDataActions.vue?vue&type=script&lang=js"
export * from "./advancedApprovalDataActions.vue?vue&type=script&lang=js"
import style0 from "./advancedApprovalDataActions.vue?vue&type=style&index=0&id=510bfde4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bfde4",
  null
  
)

export default component.exports